import {AppConfiguration} from "read-appsettings-json";
let serviceURL = AppConfiguration.Setting().Application.ServiceUrl;
let imgURL = AppConfiguration.Setting().Application.ServiceImageUrl;
let realTime = AppConfiguration.Setting().Application.RealTimeEndPoint;

export const environment = {
    production: true,
    apiEndPoint: serviceURL,
    imgSrc: imgURL,
    realTimeEndPoint: realTime,
};
